import React, {useState, useEffect} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, DatePicker, Tag} from "antd";
import {Link} from "react-router-dom";
import Select from "react-select";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import CustomPagination from "../util/CustomPagination";
import DashboardTopCards from "../dashboard/DashboardTopCards";
import UsersSearch from "../dashboard/calender/UsersSearch";
import "./assets/css/Extract.css";
import AuthService from "../login/AuthService";


const {RangePicker} = DatePicker;

const Extract = () => {
    document.title = "Extrato | Plantão Rápido";

    const userData = AuthService.getUserData();
    const [options, setOptions] = useState([]);

    const [loading, setLoading] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false);
    const [filters, setFilters] = useState({
        dateRange: [],
        datestart: null,
        dateend: null,
        status: null,
        company: null,
    });




    const [pagination, setPagination] = useState({current: 0, pageSize: 10, total: 0, lastPage: 0});
    const [duties, setDuties] = useState([]);
    const [extras, setExtras] = useState([]);



    const fetchCompanies = async () => {
        try {
            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}users/my-list-companies`, // Altere conforme o endpoint real
                {},
                true
            );

            const { data } = ApiService.handleApiResponse(response);

            const companyOptions = data.map((company) => ({
                value: company.id,
                label: company.name,
            }));

            setOptions(companyOptions);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const fetchAllExtract = async (page = 1, isExport = false) => {
        try {
            setLoadingPage(true);
            const responseType = isExport ? 'blob' : 'json';

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}duty/duty-extract`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    user_id: filters?.user_id,
                    datestart: filters?.datestart,
                    dateend: filters?.dateend,
                    companyid: filters?.company?.value,
                    isExport
                },
                true,
                responseType
            );

            if (isExport) {
                // Processa exportação de arquivo
                const blob = new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = `export_${new Date().toISOString().split("T")[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                const {data, pagination: pagInfo, extras} = ApiService.handleApiResponse(response);


                setDuties(data || []);
                setExtras(extras || []);
                setLoadingPage(false);
                setPagination(pagInfo || {current: 0, pageSize: 10, total: 0});
                setLoading(false);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    const handleClearFilters = () => {
        setFilters({
            dateRange: [],
            datestart: null,
            dateend: null,
            user_id: null,  // Usa null para limpar selects
        });

    };

    const handleSearchFiltersChange = (key, value) => {

        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    useEffect(() => {
        fetchAllExtract();
        fetchCompanies();
    }, []);




    return (

        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Extrato" pageTitle="Financeiro"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}
                        <DashboardTopCards extras={extras} loading={loading}/>


                                <div className="row mt-12 mb-12">

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Empresa</label>
                                            <Select
                                                id="companySelect"
                                                classNamePrefix="react-select"
                                                options={options}
                                                value={filters.company || null}
                                                placeholder="Selecione..."
                                                onChange={(selectedOption) =>
                                                    handleSearchFiltersChange('company', selectedOption)
                                                }
                                                isClearable
                                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                                styles={{
                                                    menuPortal: base => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }), // Definindo z-index alto
                                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Data Realização</label>
                                            <div className="form-control">
                                                <RangePicker
                                                    style={{border: "none", boxShadow: "none"}}
                                                    variant="outlined"
                                                    locale={locale}
                                                    format="DD/MM/YYYY"  // Mostra em DD/MM/YYYY na tela
                                                    className="range-picker-custom"
                                                    value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                                    onChange={(dates) => {
                                                        if (dates) {
                                                            handleSearchFiltersChange("dateRange", dates);
                                                            handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                            handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                        } else {
                                                            handleSearchFiltersChange("dateRange", []);
                                                            handleSearchFiltersChange("datestart", null);
                                                            handleSearchFiltersChange("dateend", null);
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12 d-flex justify-content-end">

                                        <button type="button" className="btn  mr-1  me-2"
                                                onClick={() =>handleClearFilters()}>
                                            <i className="fa fa-eraser"></i> Limpar Filtros
                                        </button>


                                        <button type="button" className="btn btn-dark mr-1  me-2"
                                                onClick={() => fetchAllExtract(1, true)}>
                                            <i className="fa fa-download"></i> Exportar
                                        </button>

                                        <button type="button" className="btn btn-success"
                                                onClick={() => fetchAllExtract(1, false)}>
                                            <i className="fa fa-search"></i> Buscar
                                        </button>
                                    </div>
                                </div>



                        <div className="extract-list mt-3">
                            {loading ? (
                                <Skeleton count={5} height={80}/>
                            ) : duties.length > 0 ? (
                                duties.map((duty) => (
                                    <div className="extract-item" key={duty.id}>
                                        <div className="extract-date">
                                            <span>{new Date(duty.date_time).toLocaleDateString("pt-BR")}</span>
                                            <span className="extract-time">
                                        {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </span>
                                        </div>
                                        <div className="extract-date">
                                            <span>{new Date(duty.date_time_end).toLocaleDateString("pt-BR")}</span>
                                            <span className="extract-time">
                                        {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </span>
                                        </div>
                                        <div className="extract-info">
                                            <a
                                                target="_blank"
                                                href={`/admin/location-detail/${duty.hospital?.url_page}`}
                                                className="extract-hospital-link"
                                            >
                                                {duty.hospital?.name || "Local não especificado"}
                                            </a>
                                            <div className="extract-specialtie">
                                                <strong> Empresa: {duty.user?.name || "Empresa não especificada"}</strong>
                                            </div>
                                            <div className="extract-specialtie">
                                                {duty.specialtie?.name || "Departamento não especificado"}
                                            </div>
                                        </div>
                                        <div className="extract-value me-3">
                                    <span className="extract-amount">
                                        {new Intl.NumberFormat("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        }).format(duty.value)}
                                    </span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="alert alert-primary mt-3" role="alert">Nenhum plantão encontrado.</div>
                            )}
                        </div>
                        <CustomPagination
                            className="mt-4"
                            pagination={pagination}
                            onChange={(page) => fetchAllExtract(page, false)}
                        />

                    </Row>
                </Container>
            </div>
        </React.Fragment>


    )
        ;
};

export default Extract;
